// Third-party
import { useTranslation } from 'react-i18next';

// Components

// Hooks

// Redux-toolkit
import { FC } from 'react';
import { TDialogAction, BaseDialog } from '@mgm/common/components/base';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getSelectedCommissionPlan } from '../../../store/commissions/selectors';
import { useCommissions } from '../../../hooks/useCommissions';
import { TAddCommissionPlanReq } from '../../../types/requests';

type TUnassignedMembersDialog = {
  isOpenDialog: boolean,
  setIsOpenDialog: (val: boolean) => void
};

const UnassignedMembersDialog: FC<TUnassignedMembersDialog> = ({
  isOpenDialog,
  setIsOpenDialog,
}) => {
  const { t } = useTranslation(['common', 'commissions', 'team']);
  const {
    preparePayload,
    prepareFixedCommissionData,
    prepareCommissionStepsData,
    handlePlanMutation,
    isLoading,
  } = useCommissions();

  const selectedCommissionPlan = useAppSelector(getSelectedCommissionPlan);

  const handleCloseDialog = () => {
    setIsOpenDialog(false);
  };

  const assignMembers = async () => {
    const payload = preparePayload();
    let data;

    if (selectedCommissionPlan.type === 'Fixed') {
      data = prepareFixedCommissionData(payload);
    } else {
      data = prepareCommissionStepsData(payload);
    }

    await handlePlanMutation(data as Omit<TAddCommissionPlanReq['planData'], 'creator' & 'updatedBy'>);
  };

  const dialogActions: Array<TDialogAction> = [
    {
      label: t('cancel'),
      variant: 'outlined',
      color: 'primary',
      isDisabled: isLoading,
      onClick: () => handleCloseDialog(),
    },
    {
      label: t('continue', { ns: 'team' }),
      color: 'primary',
      isLoading,
      onClick: () => assignMembers(),
    },
  ];

  return (
    <BaseDialog
      dialogWidth={450}
      dialogContent={t('youHaventAssign', { ns: 'commissions' })}
      isOpenDialog={isOpenDialog}
      dialogTitle={t('proceedWithoutAssigningMembers', { ns: 'commissions' })}
      handleClose={handleCloseDialog}
      dialogActions={dialogActions}
    />
  );
};

export {
  UnassignedMembersDialog,
};
